import dayjs from 'dayjs';

export const dateFormat = (date, format) => {
    if (typeof date === 'string') date = date.replace(/-/g, '/')
    return dayjs(date).format(format);
};